/**
 * Laravel reports a bad array item under its index (`allowed_origins.1`), but a
 * form shows the whole list in one field. Folds every `field.N` key into `field`,
 * keeping the first message, so `processApiFieldErrors` can map it.
 */
export const collapseIndexedFieldErrors = (
  invalidFields: Record<string, string | string[]> | undefined
): Record<string, string | string[]> | undefined => {
  if (!invalidFields) {
    return invalidFields
  }

  return Object.entries(invalidFields).reduce<
    Record<string, string | string[]>
  >((collapsed, [key, message]) => {
    const field = key.replace(/\.\d+$/, '')
    if (!(field in collapsed)) {
      collapsed[field] = message
    }
    return collapsed
  }, {})
}
